import React, { useEffect, useState } from 'react';
import {
  Box,
  Stack,
  FormControl,
  InputLabel,
  SelectChangeEvent,
  Select,
  MenuItem,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import { IUserType, translate } from '../../libs/utils';
import { MAIN_LIGHT_COLOR, WHITE } from '../../themes/colors';
import { UserType } from '../../configs';
import { TOPIC_LABEL } from '../../themes/fonts';

interface Props {
  targetMemberType: number;
  setTargetMemberType: (targetMemberType: number) => void;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const memberTypes: IUserType[] = [
  {
    value: UserType.REGULAR,
    type: translate('member.list.table.membership_type.regular'),
  },
  {
    value: UserType.ASSOCIATE,
    type: translate('member.list.table.membership_type.associate'),
  },
  {
    value: UserType.ADMIN_STAFF,
    type: translate('member.list.table.membership_type.admin_staff'),
  },
  {
    value: UserType.ALL_MEMBER,
    type: translate('member.list.table.membership_type.all_member'),
  },
];

const useStyles = makeStyles({
  labelContainer: {
    minWidth: 'calc(241 / 1218 * 100%) !important',
    backgroundColor: MAIN_LIGHT_COLOR,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: '18px',
    height: '100%',
  },

  textLabel: {
    color: WHITE,
    fontSize: `${TOPIC_LABEL} !important`,
    fontWeight: 'bold !important',
    textAlign: 'center',
  },

  inputField: {
    width: 'calc(718 / 959 * 100%)',
  },

  selectContainer: {
    width: '160px',
    marginLeft: '40px',
  },

  customSelectInput: {
    borderRadius: '12px !important',
    height: '50px !important',
  },

  height104: {
    height: 104,
  },
});

const TargetMemberTypeField: React.FC<Props> = ({
  targetMemberType,
  setTargetMemberType,
}) => {
  const styles = useStyles();
  const [selectedTargetMemberType, setSelectedTargetMemberType] =
    useState<number>(targetMemberType);

  const handleSelectMembershipType = (event: SelectChangeEvent) => {
    const selectedMemberType = event.target.value;
    setSelectedTargetMemberType(Number(selectedMemberType));
    setTargetMemberType(Number(selectedMemberType));
  };

  useEffect(() => {
    setSelectedTargetMemberType(targetMemberType);
  }, [targetMemberType]);

  return (
    <Stack flexDirection="row">
      <Box>
        <FormControl className={styles.selectContainer}>
          <InputLabel id="news-type-select-label">
            {translate('news.create.label.membership_type.select')}
          </InputLabel>
          <Select
            labelId="news-type-select-label"
            id="news-type-select"
            label={translate('news.create.label.membership_type.select')}
            className={styles.customSelectInput}
            onChange={handleSelectMembershipType}
            value={selectedTargetMemberType.toString()}
          >
            {memberTypes.map((type: IUserType) => (
              <MenuItem key={type.value} value={type.value}>
                {type.type}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
    </Stack>
  );
};

export default TargetMemberTypeField;
